import 'css-chunksrc/client/scenes/projectExpenseCreation/form/elementAttachments/documentCard/styles.scss';export default {
  "documentCard": "_documentCard_bgquk_1",
  "isSelected": "_isSelected_bgquk_12",
  "removeButton": "_removeButton_bgquk_16",
  "documentIcon": "_documentIcon_bgquk_29",
  "documentInfo": "_documentInfo_bgquk_34",
  "top": "_top_bgquk_48",
  "bottom": "_bottom_bgquk_61",
  "hoverContainer": "_hoverContainer_bgquk_70",
  "checkbox": "_checkbox_bgquk_88",
  "lensButton": "_lensButton_bgquk_95"
};